<div class="justify-content-center mb-4 carousel-container">
  @if (reservedIdentificationId) {
    <div class="info-with-text d-flex flex-row justify-content-between qr-merge-info">
      <div>
        <img src="assets/svg/info.svg" alt=""/>
        <span class="standard-under-text">
        {{ 'user_card.choose_digital_card_to_link' | translate }}
      </span>
      </div>
    </div>
  }
  <div class="all-cards w-100">
    @if (!isListView) {
      @if (reservedIdentificationId) {
        <h2 class="qr-merge-section-title">{{ 'user_card.individual_cards' | translate }}</h2>
      }
      <div class="cards-history-grid-container">
        @for (wrappedCard of wrappedIndividualCards; track wrappedCard) {
          <app-single-card-grid
            [singleCard]="wrappedCard"
            [isFavoriteMap]="isFavoriteMap"
            [isDeleteButtonFromHistoryActive]="false"
            [isDeleteButtonFromTeamActive]="false"
            [isDeleteButtonFromIndividualsActive]="true"
            [isStarActive]="false"
            [showEditSection]="true"
            [isIndividualCards]="true"
            [isCardActive]="wrappedCard.userCardResponse.active"
            [reservedIdentificationId]="reservedIdentificationId"
            (deleteCardFromIndividuals)="confirmDelete(wrappedCard.userCardResponse.id)"
            (activeReservedQrCard)="onActiveReservedQrCard(wrappedCard.userCardResponse.id)"
            (toggleCardFromIndividuals)="onToggleChange(wrappedCard.userCardResponse.id)"
            class="resp-flex"
          ></app-single-card-grid>
        }
      </div>
      @if (reservedIdentificationId && qrTeamForUi) {
        <h2 class="qr-merge-section-title qr-merge-section-title--spaced">{{ getTranslatedTeamName(qrTeamForUi.name) }}</h2>
        <div class="cards-history-grid-container">
          @for (wrappedCard of qrTeamWrappedCards; track wrappedCard) {
            <app-single-card-grid
              [team]="qrTeamForUi"
              [activeSubscription]="qrActiveSubscription!"
              [singleCard]="wrappedCard"
              [isFavoriteMap]="isFavoriteMap"
              [isDeleteButtonFromHistoryActive]="false"
              [isDeleteButtonFromTeamActive]="qrIsDeleteButtonActive(wrappedCard.userCardResponse)"
              [isDeleteButtonFromIndividualsActive]="false"
              [isStarActive]="wrappedCard?.userCardResponse?.userId != qrCurrentUserId"
              [showEditSection]="qrIsEditSectionVisible(wrappedCard.userCardResponse)"
              [isCardActive]="wrappedCard.userCardResponse.active"
              [isTeamCards]="true"
              [reservedIdentificationId]="reservedIdentificationId"
              (activeReservedQrCard)="onActiveReservedQrCard(wrappedCard.userCardResponse.id)"
              class="resp-flex"
            ></app-single-card-grid>
          }
        </div>
      }
    } @else {
      <div class="list-view">
        @if (reservedIdentificationId) {
          <h2 class="qr-merge-section-title">{{ 'user_card.individual_cards' | translate }}</h2>
          @if (wrappedIndividualCards.length > 0) {
            <div class="member-info-container member-info-text disable-resp">{{ 'my_team.member_info' | translate }}</div>
            <div class="line-container"></div>
          }
          @for (wrappedCard of wrappedIndividualCards; track wrappedCard) {
            <app-single-card-list
              [singleCard]="wrappedCard"
              [isFavoriteMap]="isFavoriteMap"
              [isDeleteButtonFromHistoryActive]="false"
              [isDeleteButtonFromTeamActive]="false"
              [isStarActive]="false"
              [showEditSection]="true"
              [isAdminCard]="false"
              [isIndividualCards]="true"
              [isCardActive]="wrappedCard.userCardResponse.active"
              [reservedIdentificationId]="reservedIdentificationId"
              (deleteCardFromIndividuals)="confirmDelete(wrappedCard.userCardResponse.id)"
              (toggleCardFromIndividuals)="onToggleChange(wrappedCard.userCardResponse.id)"
              (activeReservedQrCard)="onActiveReservedQrCard(wrappedCard.userCardResponse.id)"
            ></app-single-card-list>
            <label class="line-for"></label>
          }
          @if (wrappedIndividualCards.length > 0) {
            <div class="member-info-container-footer disable-resp"></div>
          }

          @if (qrTeamForUi) {
            <h2 class="qr-merge-section-title qr-merge-section-title--spaced">{{ getTranslatedTeamName(qrTeamForUi.name) }}</h2>
            @if (qrTeamWrappedCards.length > 0) {
              <div class="member-info-container member-info-text disable-resp">{{ 'my_team.members' | translate }}</div>
              <div class="line-container"></div>
            }
            @for (wrappedCard of qrTeamWrappedCards; track wrappedCard) {
              <app-single-card-list
                [team]="qrTeamForUi"
                [activeSubscription]="qrActiveSubscription!"
                [singleCard]="wrappedCard"
                [isFavoriteMap]="isFavoriteMap"
                [isDeleteButtonFromHistoryActive]="false"
                [isDeleteButtonFromTeamActive]="qrIsDeleteButtonActive(wrappedCard.userCardResponse)"
                [isStarActive]="wrappedCard?.userCardResponse?.userId != qrCurrentUserId"
                [showEditSection]="qrIsEditSectionVisible(wrappedCard.userCardResponse)"
                [currentUserEmail]="qrCurrentUserEmail ?? undefined"
                [currentUserId]="qrCurrentUserId != null ? ('' + qrCurrentUserId) : undefined"
                [reservedIdentificationId]="reservedIdentificationId"
                (activeReservedQrCard)="onActiveReservedQrCard(wrappedCard.userCardResponse.id)"
                [isAdminCard]="qrIsAdminCard(wrappedCard.userCardResponse.userId)"
                [isCardActive]="wrappedCard.userCardResponse.active"
                [isTeam]="true"
              ></app-single-card-list>
              <label class="line-for"></label>
            }
            @if (qrTeamWrappedCards.length > 0) {
              <div class="member-info-container-footer disable-resp"></div>
            }
          }
        } @else {
          @if (wrappedIndividualCards.length > 0) {
            <div class="member-info-container member-info-text disable-resp">{{ 'my_team.member_info' | translate }}</div>
            <div class="line-container"></div>
          }
          @for (wrappedCard of wrappedIndividualCards; track wrappedCard) {
            <app-single-card-list
              [singleCard]="wrappedCard"
              [isFavoriteMap]="isFavoriteMap"
              [isDeleteButtonFromHistoryActive]="false"
              [isDeleteButtonFromTeamActive]="false"
              [isStarActive]="false"
              [showEditSection]="true"
              [isAdminCard]="false"
              [isIndividualCards]="true"
              [isCardActive]="wrappedCard.userCardResponse.active"
              [reservedIdentificationId]="reservedIdentificationId"
              (deleteCardFromIndividuals)="confirmDelete(wrappedCard.userCardResponse.id)"
              (toggleCardFromIndividuals)="onToggleChange(wrappedCard.userCardResponse.id)"
              (activeReservedQrCard)="onActiveReservedQrCard(wrappedCard.userCardResponse.id)"
            ></app-single-card-list>
            <label class="line-for"></label>
          }
          @if (wrappedIndividualCards.length > 0) {
            <div class="member-info-container-footer disable-resp"></div>
          }
        }
      </div>
    }
  </div>
</div>
